<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :width="width" :height="height"><g :fill="_secondaryfill"><path d="M27,16a1.234,1.234,0,0,0-.4-.8l-18-13a1.073,1.073,0,0,0-1.1-.1A1.05,1.05,0,0,0,7,3V29a1.05,1.05,0,0,0,.5.9A.9.9,0,0,0,8,30a1.421,1.421,0,0,0,.6-.2l18-13A1.234,1.234,0,0,0,27,16Z" :fill="fill" /></g></svg>
</template>

<script>
	export default {
		props: {
			width: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			height: {
				type: [
					Number,
					String
				],
				default: '100%'
			},
			strokewidth: {
				type: [
					Number,
					String
				],
				default: 1
			},
			fill: {
				type: String,
				default: 'currentColor'
			},
			secondaryfill: {
				type: String
			}
		},
		computed: {
			_secondaryfill() {
				return this.secondaryfill || this.fill;
			}
		}
	};
</script>